import type { FaireProductEntity } from "../../entity_types/product";

export const p_gn4gb796n4: FaireProductEntity = {
  token: "p_gn4gb796n4",
  type: "product",
  name: "Ruffle Waist Solid Evening Gown",
  brandToken: "b_4z8um3dept",
  brandName: "Sheer Trend",
  imageUrl:
    "https://cdn.faire.com/fastly/e187a3dc1ce0d723e6e87e5b88d3122b74ee0a7a7082fab751e79adb755bfc4e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2977ed8a7a28f5fd32ea19e74557852c39acf46695992e8be1832816d1a1fdd7.jpeg",
    "https://cdn.faire.com/fastly/0499bb7afc9bacce3658115a33c885576ec6321800bac33c111f65c73a3e5d10.jpeg",
    "https://cdn.faire.com/fastly/8dce591a357e2a80f753f67814e6ecba14548d87e81c6a41933bec4e50f57656.jpeg",
    "https://cdn.faire.com/fastly/952f08be2f2190cc22d84af5cb9b00a8b23ab5be478c678c9e43a380aa8079e1.jpeg",
    "https://cdn.faire.com/fastly/4be1edae1743ec714b62a573af2eb6284db7ef4c88593cb129837d2fc1f5d60f.jpeg",
  ],
  priceDollars: 19.99,
  description:
    "Material:Polyester\n\nStyle:Look-thin\n\nFeature:Paneled\n\nNeckline:V-neck\n\nOccasion:Evening\n\nSeasons:Summer\n\nType:Maxi Dresses\n\nSleeve Length:Sleeveless\n\nSize S (inch) : Bust= 31.98 ; Waist= 24.18 ; Hips= 47.19 ; Hemline= 97.50 ; Length= 58.70 ; \n\nSize M (inch) : Bust= 33.54 ; Waist= 25.74 ; Hips= 48.75 ; Hemline= 99.06 ; Length= 59.28 ; \n\nSize L (inch) : Bust= 35.10 ; Waist= 27.30 ; Hips= 50.31 ; Hemline= 100.62 ; Length= 59.87 ; \n\nSize XL (inch) : Bust= 36.66 ; Waist= 28.86 ; Hips= 51.87 ; Hemline= 102.18 ; Length= 60.45 ; \n\nDiscover our elegant ruffle waist solid evening gown, perfect for formal events and special occasions. This stunning dress features a flattering ruffle waist design and timeless solid color, offering a chic and sophisticated look. Ideal for prom, weddings, or cocktail parties, it combines comfort with style. Shop now for the best ruffle waist evening gown to enhance your wardrobe and make a lasting impression. \n\n#Ruffle Waist Evening Gown, #Solid Evening Gown, #Ruffle Waist Gown, #Evening Gown with Ruffle, #Solid Ruffle Gown, #Formal Ruffle Dress, #Elegant Evening Gown, #Waist Ruffle Gown, #Party Gown with Ruffle, #Evening Dress with Ruffle Waist,\n",
  tags: [],
  msrpDollars: 39.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:49.841Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
